import moment from 'moment';

export class DateUtil {
    public static getLocalNow(): moment.Moment {
        return moment().local();
    }

    public static getUtcNow(): moment.Moment {
        return moment().utc();
    }

    public static create(year: number, month: number, day: number, hour?: number, minute?: number, second?: number, millisecond?: number): moment.Moment {
        return moment({
            year: year,
            month: month - 1,
            day: day,
            hour: hour ?? 0,
            minute,
            second: second ?? 0,
            millisecond: millisecond ?? 0
        });
    }

    public static parse(
        value: any,
        isUtc?: boolean,
        inFormat?: moment.MomentFormatSpecification
    ): moment.Moment | null {
        if (value == null || value === '') {
            return null;
        }

        isUtc ??= true;
        inFormat ??= moment.ISO_8601;

        let date = isUtc ? moment.utc(value, inFormat).local() : moment(value, inFormat).local();

        return date.isValid() ? date : null;
    }

    public static formatDate(
        value: any,
        isUtc?: boolean,
        outFormat?: string,
        inFormat?: moment.MomentFormatSpecification
    ): string | null {
        isUtc ??= true;
        outFormat ??= 'DD/MM/YYYY';
        inFormat ??= moment.ISO_8601;

        return DateUtil.parse(value, isUtc, inFormat)?.format(outFormat) ?? null;
    }

    public static formatTime(
        value: any,
        outFormat?: string,
        inFormat?: string
    ): string | null {
        if (value == null || value === '') {
            return null;
        }

        outFormat ??= 'hh:mm A';
        inFormat ??= 'HH:mm';

        let time = moment(value, inFormat);

        return time.isValid() ? time.format(outFormat) : null;
    }

    public static formatDateTime(
        value: any,
        isUtc?: boolean,
        outFormat?: string,
        inFormat?: moment.MomentFormatSpecification
    ): string | null {
        isUtc ??= true;
        outFormat ??= 'DD/MM/YYYY hh:mm A';
        inFormat ??= moment.ISO_8601;

        return DateUtil.parse(value, isUtc, inFormat)?.format(outFormat) ?? null;
    }
}
